import driftImg from "../assets/Products/drift.png";
import depthImg from "../assets/Products/depth.png";
import lightImg from "../assets/Products/light.png";
import { API_ORIGIN } from "../api/client.js";

const LOCAL_MEDIA_URLS = {
  "/media/products/drift.png": driftImg,
  "/media/products/depth.png": depthImg,
  "/media/products/light.png": lightImg,
};

export const resolveProductMediaUrl = (url) => {
  if (LOCAL_MEDIA_URLS[url]) return LOCAL_MEDIA_URLS[url];
  if (url?.startsWith("/uploads/")) return `${API_ORIGIN}${url}`;
  return url;
};
